(function () {
  const mainButton = document.querySelector('.size-guide__button');

  if (!mainButton) return;

  document.addEventListener('productoptions.appLoad', (event) => {
    const fields = event.detail.fields;
    // should be an array of arrays, where each inner array represents a field set
    if (!Array.isArray(fields) || fields.length === 0) return;

    const firstFieldSet = fields[0];

    if (!firstFieldSet) return;

    // Get first selectable field
    const selectFields = firstFieldSet.filter(
      (field) => field.type === 'combo_select' || field.type === 'select' || field.type === 'combo_image' || field.type === 'swatch_select_image'
    );

    if (selectFields.length === 0) return;

    const firstField = selectFields[0];
    if (!firstField) return;

    const fieldKey = firstField.key;

    if (!fieldKey) return;

    const firstOption = document.querySelector(`
        .avp-option[key="${fieldKey}"] .ap-label-tooltip
    `);

    if (!firstOption) return;

    // Check if the button is already inside to avoid duplicating
    if (!firstOption.contains(mainButton)) {
      firstOption.appendChild(mainButton);
    }

    // Ensure it is visible (if it was hidden before)
    mainButton.style.display = '';
  });
})();
